import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// React Router behält per default die Scroll-Position beim
// Route-Wechsel — wer aus einer weit gescrollten Seite (z.B.
// B2B-AGB § 11) einen Link in ein langes Folge-Dokument (z.B.
// AVV) klickt, landet dort mitten im Inhalt statt oben. Diese
// Komponente einmal innerhalb des <Router> montieren; sie scrollt
// bei jedem pathname-Wechsel auf den Seitenanfang.
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
